import styles from "./styles.module.css";
import type { IconType } from "react-icons";
import { Link } from "react-router-dom";
import NumberFlow from "@number-flow/react";
import { motion } from "motion/react";
import { forwardRef } from "react";

type Colors = "green" | "crimson" | "cyan" | "purple" | "gold";

export interface AnalyticsProps {
  color: Colors;
  Icon: IconType;
  count: number;
  title: string;
  url: string;
  colorInner: string;
  position: number;
}

const AnalyticsCard = forwardRef<HTMLAnchorElement, AnalyticsProps>(
  ({ Icon, color, count, title, url = "/#", position }, ref) => {
    return (
      <Link to={url} className={styles.flex} ref={ref}>
        <motion.div
          className={styles.container}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: position * 0.1 }}
        >
          <div className={styles.titleContainer}>
            <div className={`${styles.icon} ${styles[color]}`}>
              <Icon size={20} />
            </div>
            <p className={styles.title}>{title}</p>
          </div>
          <div>
            <div className={styles.count}>
              <NumberFlow value={count} />
            </div>
          </div>
        </motion.div>
      </Link>
    );
  }
);

export default AnalyticsCard;
